/**
 * UNE TOUCHE PAR OUTIL — item D.949. L'objet est LA source : le banc lit ses
 * clés, et TypeScript refuse une clé en double dans un littéral — deux outils
 * ne peuvent pas se disputer une touche sans rougir à la compilation.
 * Les touches OUVRENT un outil ; Échap ferme — jamais l'inverse.
 *
 * ⚠️ MODULE SANS JSX, ET C'EST LE POINT. Il vivait dans `atelier.tsx` ; le
 * banc qui le lit l'importait donc en `.tsx`, et `tsconfig.tests.json` n'a ni
 * `jsx` ni `DOM` — le PRÉ-VOL du déployeur a rougi là où mes trois `tsc`
 * locaux passaient (11/10/2026). Un contrat partagé entre un écran et un banc
 * vit dans un module de données, jamais dans un composant.
 */
export const TOUCHES_ATELIER = {
  e: 'emprise',
  b: 'bornes',
  v: 'voie',
  c: 'chantier',
} as const;
